import {useLayoutQuery} from '../page-data/loaders/use-layout-query'

export function useCanUseAgentCommentExperience() {
  return useLayoutQuery().data.user.canUseAgentCommentExperience === true
}
